import { apiActions } from '../app/actions';
import { makeRequest } from '../lib/fetch';
import { fireMessageEvent } from '../messenger/utils';

export const fetchHistoryData = () => (dispatch, getState) => {
  const { config } = getState();
  const { apiUrl, graphqlUrl, language, env, userId, currentSession, platform } = config;

  const { fetchStart, fetchSuccess, fetchFailure } = apiActions('history_data');

  dispatch(fetchStart());

  return makeRequest({
    method: 'GET',
    route: 'pickHistory',
    apiUrl,
    graphqlUrl,
    language,
    platform,
    env,
    userId,
    currentSession,
  }).then(
    (resp) => {
      if (resp.code === 'serverError') {
        return dispatch(fetchFailure(resp));
      }

      return dispatch(fetchSuccess(resp));
    },
    (err) => {
      if (err.status === 401) {
        return dispatch(apiActions('auth').fetchFailure());
      }
      const messageData = {
        err,
        route: 'pickHistory',
        apiUrl,
        userId,
        currentSession,
      };
      fireMessageEvent({
        type: 'ERROR',
        platform,
        title: 'hockey-challenge-error',
        data: messageData,
      });
      if (err.code === 500) {
        return dispatch(apiActions('data_500').fetchFailure(err));
      }
      dispatch(fetchFailure(err));
    },
  );
};

export const fetchUserStats = () => (dispatch, getState) => {
  const { config } = getState();
  const { apiUrl, graphqlUrl, language, env, userId, currentSession, platform } = config;

  const { fetchStart, fetchSuccess, fetchFailure } = apiActions('user_stats');
  const { fetchFailure: authFailure } = apiActions('auth');

  dispatch(fetchStart());

  return makeRequest({
    method: 'GET',
    apiUrl,
    graphqlUrl,
    language,
    platform,
    userId,
    route: 'userStats',
    env,
    currentSession,
  }).then(
    (resp) => {
      if (resp.code === 'serverError') {
        return dispatch(fetchFailure(resp));
      }

      if (resp.code === 'noContest') {
        return dispatch(fetchFailure(resp));
      }

      return dispatch(fetchSuccess(resp));
    },
    (err) => {
      if (err.status === 401) {
        return dispatch(authFailure());
      }
      const messageData = {
        err,
        route: 'userStats',
        apiUrl,
        userId,
        currentSession,
      };
      fireMessageEvent({
        type: 'ERROR',
        platform,
        title: 'hockey-challenge-error',
        data: messageData,
      });
      if (err.code === 500) {
        return dispatch(apiActions('data_500').fetchFailure(err));
      }
      dispatch(fetchFailure(err));
    },
  );
};
